import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4 relative mt-4" }

import {
  computed,
  onBeforeUnmount,
  ref,
  watch,
  PropType,
  ComputedRef,
} from 'vue';

import { NkModal, NkGrid, NkCol } from '@/core/components';

import { UPDATE_MODEL_EVENT } from '@/core/consts';

import { useGetTypeDeviceModel, useGetTypeQuery, useGetTypesQuery } from '@/entities/type/hooks';

import { ChildrenForModel, Type } from '@/entities/type/types';
import { CreateDeviceData } from '@/entities/device/types';

import NkDeviceCard from '../device-card/NkDeviceCard.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceModelChoiceModal',
  props: {
  typeId: {
    type: Number as PropType<Type['id']>,
    required: true,
  },
  fields: {
    type: Object as PropType<CreateDeviceData>,
    required: true,
  },
  modelValue: {
    type: Object as PropType<CreateDeviceData>,
    default: null,
  },
},
  emits: [UPDATE_MODEL_EVENT, 'close'],
  setup(__props, { emit }) {

const props = __props





const isVisible = ref(false);
const isSuccessAlertVisible = ref(false);

const typeQueryData = computed(() => ({ id: props.typeId }));

const { data: type } = useGetTypeQuery(typeQueryData);
const { data: types } = useGetTypesQuery();

const subDevices: ComputedRef<CreateDeviceData[]> = computed(() => props.fields?.subDevices || []);

const existingTypes = computed(() => subDevices.value?.map(device => device.type) || []);

const childrenForModel: ComputedRef<ChildrenForModel[]> = computed(() => type.value?.childrenForModel?.map(o => ({
  type: (types.value?.find(t => t.id === o.type) as Type),
  repetition: o.repetition,
})) || []);

const allowedChildrenForModel = computed(() => childrenForModel.value?.filter(tc => {
  const repetitions = existingTypes.value?.reduce((acc, current) => acc + (current === (tc.type as Type).id ? 1 : 0), 0);

  return repetitions < tc.repetition;
}));

const selectedModelTypeId = ref();
const selectedModelTypeData: ComputedRef = computed(() => ({ id: selectedModelTypeId.value }));
const isSelectedModelTypeIdDefined: ComputedRef = computed(() => !!selectedModelTypeId.value);

const { data: selectedSubDeviceModel } = useGetTypeDeviceModel(selectedModelTypeData, {
  staleTime: Infinity,
  enabled: isSelectedModelTypeIdDefined,
});


const showSuccessAlert = () => {
  isSuccessAlertVisible.value = true;
  setTimeout(() => {
    isSuccessAlertVisible.value = false;
  }, 3000);
};

watch(() => selectedSubDeviceModel.value, async (value: CreateDeviceData) => {
  await emit(UPDATE_MODEL_EVENT, value);
  selectedModelTypeId.value = null;
  showSuccessAlert();
});

watch(() => isVisible.value, (visible: boolean) => {
  if (!visible) {
    selectedModelTypeId.value = null;
  }
});

const onOpen = () => {
  if (allowedChildrenForModel.value.length === 1) {
    selectedModelTypeId.value = ((allowedChildrenForModel.value[0] as ChildrenForModel)?.type as Type)?.id;
    return true;
  }

  isVisible.value = true;
  return isVisible.value;
};

onBeforeUnmount(() => {
  isVisible.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_unref(allowedChildrenForModel).length)
    ? (_openBlock(), _createBlock(_unref(NkModal), {
        key: 0,
        title: _ctx.$t('device.action.subdevice_type_choice'),
        class: "max-w-screen-md",
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isVisible).value = $event))
      }, {
        reference: _withCtx(() => [
          _createElementVNode("span", {
            class: "inline",
            onClick: onOpen
          }, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_Transition, {
              "enter-active-class": "transition-all",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                (isSuccessAlertVisible.value)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 0,
                      type: "success",
                      closable: false,
                      class: "absolute -top-1.5 inset-x-0 h-[40px] transform -translate-y-full",
                      title: _ctx.$t('device.action.subdevice_type_success')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkGrid), null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allowedChildrenForModel), (model, i) => {
                  return (_openBlock(), _createBlock(_unref(NkCol), {
                    span: _unref(allowedChildrenForModel).length <= 1 ? 12 : 6,
                    key: model.type.id,
                    align: _unref(allowedChildrenForModel).length <= 1 ? 'center' : (i % 2 === 0 ? 'right' : 'left')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(NkDeviceCard, {
                        type: model.type.id,
                        selected: selectedModelTypeId.value === model.type.id,
                        onClick: ($event: any) => (selectedModelTypeId.value = model.type.id)
                      }, null, 8, ["type", "selected", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["span", "align"]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["title", "modelValue"]))
    : _createCommentVNode("", true)
}
}

})